import './VideoBlock.scss'

import React from 'react'
import {WysiwygType} from '../../types'
import {style} from '../../util/style'
import {Theme} from '../../views/Theme'
import {Video, VideoType} from '../ui/Video'
import {Block} from './Blocks'

const styles = style('videoblock')

export type VideoBlockType = VideoType & {
	caption?: WysiwygType
}

export const VideoBlock: React.FC<VideoBlockType & {container?: boolean}> = ({
	container,
	video,
	caption,
	cookie_services
}) => {
	if (!video) return null

	return (
		<Block className={styles()} container={container}>
			<figure className={styles('container')}>
				<Video video={video} cookie_services={cookie_services} />
				{caption && (
					<figcaption className={styles('caption')}>
						<Theme.Wysiwyg>{caption}</Theme.Wysiwyg>
					</figcaption>
				)}
			</figure>
		</Block>
	)
}
